<template>
  <div>
    <div class="TopShowBox">
      <div class="ChildTopShowBox">
        <div class="notification-container">
          <div class="notification-icon">
            <VsxIcon @click="toggleNotifications" iconName="NotificationBing" :size="25" :color="color" type="linear" />
            <span v-if="unreadCount" class="notification-badge">{{ unreadCount }}</span>
          </div>
          <div v-if="showNotifications" class="notification-submenu">
            <div v-if="userAlerts.length > 0" class="notification-header">
              <div class="notification-header-content">
                <h3>{{ currentLang === 'fa' ? 'اعلان‌ها' : 'Notifications' }}</h3>
                <button @click="markAllAlertsAsRead" class="read-all-btn" :disabled="markingAllRead">
                  <VsxIcon v-if="!markingAllRead" iconName="TickCircle" :size="16" color="#666" type="linear" />
                  <VsxIcon v-else iconName="InfoCircle" :size="16" color="#666" type="linear" />
                  <span>{{ markingAllRead ? (currentLang === 'fa' ? 'در حال پردازش...' : 'Processing...') : (currentLang === 'fa' ? 'خواندن همه' : 'Read All') }}</span>
                </button>
              </div>
            </div>
            <div class="notification-list">
              <div v-if="userAlerts.length === 0 && !loading" class="notification-item empty">
                <p>{{ currentLang === 'fa' ? 'هیچ اعلانی وجود ندارد' : 'No notifications' }}</p>
              </div>

              <div v-if="userAlerts.length === 0 && loading" class="notification-item loading">
                <p>{{ currentLang === 'fa' ? 'در حال بارگذاری...' : 'Loading...' }}</p>
              </div>
              
              <div v-for="(alert, index) in userAlerts" :key="'alert-'+index"
                   class="notification-item"
                   :class="{ [alert.type]: true, 'unread': !alert.is_read }">
                <div class="notification-item-header">
                  <VsxIcon :iconName="getAlertIcon(alert.type)" :size="20" :color="getIconColor(alert.type)" type="linear" />
                  <h4>{{ alert.title }}</h4>
                  <div class="notification-actions">
                    <button v-if="!alert.is_read" @click="markAlertAsRead(alert.id)" class="mark-read-btn" title="علامت گذاری به عنوان خوانده شده">
                      <VsxIcon iconName="TickCircle" :size="16" color="#666" type="linear" />
                    </button>
                  </div>
                </div>

                <p>{{ alert.message }}</p>

                <div class="notification-footer">
                  <small class="notification-time">{{ formatTime(alert.created_at) }}</small>
                  <small v-if="alert.data && alert.data.admin_note" class="admin-note">
                    {{ alert.data.admin_note }}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <router-link to="/ticket" class="nav-item">
          <VsxIcon iconName="Messages1" :size="25" :color="color" type="linear" />
        </router-link>
      </div>

      <router-link to="/home">
        <div class="TextChildTopShowBox">
          <h1>{{ $t('headerMenu.title') }}</h1>
        </div>
      </router-link>
     

      <div class="ChildTopShowBox">
        <VsxIcon @click="changeLanguage" iconName="Translate" :size="25" :color="color" type="linear" />
        <VsxIcon @click="changeThem" iconName="Sun1" :size="25" :color="color" type="linear" />
      </div>
    </div>
  </div>
</template>
<script>
import axios from "@/axios";
import { toast } from "vue3-toastify";

export default {
  name: "HeaderMenu",
  data() {
    return {
      isDark: false,
      color: localStorage.getItem('theme') === 'dark' ? '#BB86FC' : '#2E1977',
      showNotifications: false,
      notifications: [],
      userAlerts: [],
      unreadAlertsCount: 0,
      loading: false,
      markingAllRead: false
    };
  },
  computed: {
    currentLang() {
      return this.$store.state.currentLang;
    },
    theme() {
      return this.$store.state.theme;
    },
    unreadCount() {
      return this.notifications.filter(n => !n.isRead).length + this.unreadAlertsCount;
    }
  },
  methods: {
    toggleNotifications() {
      this.showNotifications = !this.showNotifications;
      
      // Only fetch data when opening the notifications panel
      if (this.showNotifications) {
        this.loading = true;
        
        // Clear previous data
        this.notifications = [];
        
        // Fetch new data
        this.fetchUserAlerts();
      }
    },
    async fetchNotifications() {
      const userData = localStorage.getItem('userData') || localStorage.getItem('user');
      const userData1 = userData ? JSON.parse(userData) : null;
      
      if (!userData1 || !userData1.id) {
        this.loading = false;
        return;
      }
      
      let attempts = 0;
      const maxAttempts = 10;
      const delay = 100;
      
      while (attempts < maxAttempts) {
        try {
          const response = await axios.post('/get-notifications', {
            user_id: userData1.id
          });
          
          if (response.data) {
            this.notifications = response.data;
          }
          
          this.loading = false;
          return;
        } catch (error) {
          console.error('Error fetching notifications:', error);
          attempts++;
          await new Promise(resolve => setTimeout(resolve, delay));
        }
      }
      
      // If all attempts fail, set a fallback notification
      this.notifications = [{
        id: 'fallback',
        title: 'سیستم',
        message: 'خطا در دریافت اطلاعات',
        icon: 'InfoCircle',
        type: 'info',
        isRead: false,
        time: 'هم اکنون'
      }];
      
      this.loading = false;
    },
    async fetchUserAlerts() {
      const storedUsers = ['userData', 'user']
        .map(key => {
          try {
            const value = localStorage.getItem(key);
            return value ? JSON.parse(value) : null;
          } catch (error) {
            return null;
          }
        })
        .filter(Boolean);
      const user = storedUsers.find(value => value.id || value.user_id || value.user?.id || value.user?.user_id);
      const userId = user?.id || user?.user_id || user?.user?.id || user?.user?.user_id;

      if (!userId) {
        this.loading = false;
        return;
      }
      
      let attempts = 0;
      const maxAttempts = 10;
      const delay = 100;
      
      while (attempts < maxAttempts) {
        try {
          const response = await axios.post('/get-user-alerts', {
            user_id: userId,
            language: this.currentLang
          });

          if (response.data && response.data.success) {
            this.userAlerts = response.data.data.alerts || [];
            this.unreadAlertsCount = response.data.data.unread_count || 0;
          }

          this.loading = false;
          return;
        } catch (error) {
          console.error('Error fetching user alerts:', error);
          attempts++;
          await new Promise(resolve => setTimeout(resolve, delay));
        }
      }

      // If all attempts failed, set loading to false
      this.loading = false;

      // If we've reached this point, all attempts failed
      toast("خطا در دریافت هشدارها", {
        autoClose: 3000,
        position: "top-right",
        type: "error",
      });
    },
    async markAlertAsRead(alertId) {
      const userData = localStorage.getItem('userData') || localStorage.getItem('user');
      const userData1 = userData ? JSON.parse(userData) : null;

      if (!userData1 || !userData1.id) {
        return;
      }

      try {
        const response = await axios.post('/mark-alert-read', {
          alert_id: alertId,
          user_id: userData1.id,
          language: this.currentLang
        });

        if (response.data && response.data.success) {
          // Update the alert as read in the local array
          const alertIndex = this.userAlerts.findIndex(alert => alert.id === alertId);
          if (alertIndex !== -1) {
            this.userAlerts[alertIndex].is_read = true;
            this.unreadAlertsCount = Math.max(0, this.unreadAlertsCount - 1);
          }

          toast("هشدار به عنوان خوانده شده علامت گذاری شد", {
            autoClose: 2000,
            position: "top-right",
            type: "success",
          });
        }
      } catch (error) {
        console.error('Error marking alert as read:', error);
        toast("خطا در علامت گذاری هشدار", {
          autoClose: 3000,
          position: "top-right",
          type: "error",
        });
      }
    },
    async markAllAlertsAsRead() {
      const userData = localStorage.getItem('userData') || localStorage.getItem('user');
      const userData1 = userData ? JSON.parse(userData) : null;

      if (!userData1 || !userData1.id) {
        return;
      }

      // Check if there are any unread alerts
      const hasUnreadAlerts = this.userAlerts.some(alert => !alert.is_read);
      if (!hasUnreadAlerts) {
        toast(this.currentLang === 'fa' ? 'همه اعلان‌ها قبلاً خوانده شده‌اند' : 'All notifications are already read', {
          autoClose: 2000,
          position: "top-right",
          type: "info",
        });
        return;
      }

      this.markingAllRead = true;

      try {
        const response = await axios.post('/mark-all-alerts-read', {
          user_id: userData1.id,
          language: this.currentLang
        });

        if (response.data && response.data.success) {
          // Mark all alerts as read in the local array
          this.userAlerts.forEach(alert => {
            alert.is_read = true;
          });
          this.unreadAlertsCount = 0;

          toast(this.currentLang === 'fa' ? 'همه اعلان‌ها خوانده شدند' : 'All notifications marked as read', {
            autoClose: 2000,
            position: "top-right",
            type: "success",
          });
        }
      } catch (error) {
        console.error('Error marking all alerts as read:', error);
        toast(this.currentLang === 'fa' ? 'خطا در خواندن اعلان‌ها' : 'Error marking notifications as read', {
          autoClose: 3000,
          position: "top-right",
          type: "error",
        });
      } finally {
        this.markingAllRead = false;
      }
    },
    handleClickOutside(event) {
      const notificationContainer = this.$el.querySelector('.notification-container');
      if (notificationContainer && !notificationContainer.contains(event.target)) {
        this.showNotifications = false;
      }
    },
    changeThem(){
      const newTheme = this.theme === 'light' ? 'dark' : 'light';
      this.$store.dispatch('changeTheme', newTheme);
      this.$emit('messageSent', newTheme);
    },

    formatPrice(value) {
      let val = (value/1).toFixed(0).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    formatTime(dateString) {
      if (!dateString) return '';

      const date = new Date(dateString);
      const now = new Date();
      const diffInSeconds = Math.floor((now - date) / 1000);

      if (diffInSeconds < 60) {
        return 'هم اکنون';
      } else if (diffInSeconds < 3600) {
        const minutes = Math.floor(diffInSeconds / 60);
        return `${minutes} دقیقه پیش`;
      } else if (diffInSeconds < 86400) {
        const hours = Math.floor(diffInSeconds / 3600);
        return `${hours} ساعت پیش`;
      } else if (diffInSeconds < 604800) {
        const days = Math.floor(diffInSeconds / 86400);
        return `${days} روز پیش`;
      } else {
        return date.toLocaleDateString('fa-IR');
      }
    },

    loadTheme() {
      if( this.theme === "light"){
        this.color = '#2E1977'
      }else{
        this.color = '#BB86FC'
      }
    },

    changeLanguage() {
      const newLang = this.currentLang === 'fa' ? 'en' : 'fa';
      this.$store.dispatch('changeLanguage', newLang);

      this.$i18n.locale = newLang;

      document.documentElement.dir = newLang === 'fa' ? 'rtl' : 'ltr';
      document.body.dir = newLang === 'fa' ? 'rtl' : 'ltr';

      this.$emit('languageChanged', newLang);
    },

    loadLanguage() {
      this.$i18n.locale = this.currentLang;
      document.documentElement.dir = this.currentLang === 'fa' ? 'rtl' : 'ltr';
      document.body.dir = this.currentLang === 'fa' ? 'rtl' : 'ltr';
    },

    getIconColor(type) {
      const colors = {
        danger: '#ff4444',
        warning: '#ff9f00',
        info: '#007bff',
        success: '#00c300',
        primary: '#4c7de6',
        security: '#00c300'
      };
      return colors[type] || this.color;
    },
    
    getAlertIcon(type) {
      const icons = {
        danger: 'CloseCircle',
        warning: 'Warning2',
        info: 'InfoCircle',
        success: 'TickCircle',
        primary: 'TickCircle'
      };
      return icons[type] || 'InfoCircle';
    }
  },
  mounted(){
    this.loadLanguage();
    this.loadTheme();
    this.fetchUserAlerts();
    document.addEventListener('click', this.handleClickOutside);

    // Auto refresh alerts every 30 seconds
    this.alertRefreshInterval = setInterval(() => {
      if (!this.showNotifications) {
        this.fetchUserAlerts();
      }
    }, 5000);

    setInterval(() => {
      this.loadTheme()
    }, 100);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
    if (this.alertRefreshInterval) {
      clearInterval(this.alertRefreshInterval);
    }
  }
}
</script>

<style scoped>
.notification-container {
  position: relative;
  cursor: pointer;
}

.notification-icon {
  position: relative;
  display: inline-block;
}

.notification-badge {
  position: absolute;
  top: -10px;
  right: -10px;
  background: #ff4444;
  color: white;
  border-radius: 50%;
  font-size: 11px;
  min-width: 18px;
  text-align: center;
  width: 20px;
  height: 20px;
}

.notification-submenu {
  position: absolute;
  top: 170%;
  right: 0;
  background: var(--bg-color, #fff);
  border: 1px solid var(--border-color, #e0e0e0);
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  min-width: 320px;
  max-width: 400px;
  max-height: 400px;
  overflow-y: auto;
  z-index: 1000;
}

.notification-header {
  padding: 12px 16px;
  border-bottom: 1px solid var(--border-color, #eee);
  background: var(--input-background, #f8f9fa);
}

.notification-header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.notification-header h3 {
  margin: 0;
  font-size: 16px;
  
  color: var(--text-primary, #333);
}

.read-all-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: var(--primary-color, #4c7de6);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.read-all-btn:hover:not(:disabled) {
  background: var(--secondary-color, #3b5bbf);
  transform: translateY(-1px);
}

.read-all-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.read-all-btn span {
  white-space: nowrap;
}

.notification-list {
  padding: 8px 0;
}

.notification-item {
  padding: 12px 16px;
  border-bottom: 1px solid var(--border-color, #eee);
  transition: all 0.2s ease;
}

.notification-item:last-child {
  border-bottom: none;
}

.notification-item:hover {
  background-color: var(--hover-bg, #f8f9fa);
}

.notification-item.unread {
  background-color: var(--unread-bg, #f8f9ff);
}

.notification-item.warning {
  border-right: 4px solid #ff9f00;
}

.notification-item.info {
  border-right: 4px solid #007bff;
}

.notification-item.security {
  border-right: 4px solid #00c300;
}

.notification-item.success {
  border-right: 4px solid #00c300;
}

.notification-item.danger {
  border-right: 4px solid #ff4444;
}

.notification-item.primary {
  border-right: 4px solid #4c7de6;
}

.notification-item.empty {
  text-align: center;
  color: #888;
  font-style: italic;
}

.notification-item.loading {
  text-align: center;
  color: #666;
}

.notification-item-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.notification-item-header h4 {
  margin: 0;
  font-size: 14px;
  
  color: #333;
  flex: 1;
}

.notification-actions {
  display: flex;
  gap: 4px;
}

.mark-read-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.mark-read-btn:hover {
  background-color: rgba(0, 195, 0, 0.1);
}

.notification-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
}

.notification-time {
  color: #888;
  font-size: 11px;
}

.admin-note {
  color: #666;
  font-size: 11px;
  font-style: italic;
}

.notification-item p {
  margin: 0 0 8px 0;
  font-size: 13px;
  line-height: 1.5;
  color: #666;
}

.notification-item small {
  display: block;
  font-size: 12px;
  color: #888;
}

.notification-item small a {
  color: #4c7de6;
  text-decoration: none;
}

.notification-item small a:hover {
  text-decoration: underline;
}
</style>
